module.exports = __webpack_public_path__ + "img/programs-white-icon.a52836a3.png";